/** @format */

import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const skeletonStyle = { backgroundColor: 'rgba(0, 0, 0, 0.1)' };

const WidgetCardSkeleton = () => (
  <Grid
    className="dashboard-skeleton__card"
    container
    direction="column"
    spacing={1}
    style={{ padding: 16, height: 376, borderRadius: 16 }}
  >
    <Grid item>
      <Skeleton variant="text" width="60%" height={24} style={skeletonStyle} />
    </Grid>
    <Grid item>
      <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="70%" height={20} style={skeletonStyle} />
    </Grid>
    <Grid item style={{ marginTop: 'auto' }}>
      <Skeleton variant="rect" width={80} height={32} style={{ ...skeletonStyle, borderRadius: 4 }} />
    </Grid>
  </Grid>
);

export const DashboardSkeleton = () => {
  return (
    <div className="container-grid container-grid-dashboard-skeleton">
      <div className="dashboard-widgets-outer">
        <div className="dashboard-skeleton dashboard-widgets">
          <Grid container spacing={3} style={{ marginTop: 0, marginBottom: 0 }}>
            {[1, 2, 3, 4, 5, 6].map(i => (
              <Grid item xs={12} sm={6} md={i < 4 ? 4 : i < 6 ? 6 : 12} key={i}>
                <div className="dashboard-skeleton__card-wrapper">
                  <WidgetCardSkeleton />
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
};
